import React from 'react';

import { Chip } from '@mui/material';
import _ from 'es-toolkit/compat';

import { PaymentHistoryItemStatus } from '@clearverify/constants';
import { formatPaymentHistoryItemStatus } from '@clearverify/utils';

import 'src/theme/chip';

import { StripeBillingTransactionStatus } from 'src/api';

import { PaymentHistoryItemChipStyles } from './styles';

interface PaymentHistoryItemChipProps {
  status: StripeBillingTransactionStatus;
  isRefunded?: boolean;
}

export const PaymentHistoryItemChip: React.FC<PaymentHistoryItemChipProps> = ({
  status,
  isRefunded,
}) => {
  const label = formatPaymentHistoryItemStatus(status, isRefunded);

  const sx = isRefunded
    ? PaymentHistoryItemChipStyles[PaymentHistoryItemStatus.Refunded]
    : _.get(PaymentHistoryItemChipStyles, status || PaymentHistoryItemStatus.Failed);

  return <Chip label={label} size="small" variant="filled" sx={sx} />;
};
